export enum PreprintRequestType {
  Withdrawal = 'withdrawal',
}
